import { Component, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CustomModalComponent } from 'hig-ng-lib';
import { LoaderService } from '../../../../core/services/loading.service';

@Component({
    selector: 'app-reports-burst-grid-popup',
    templateUrl: './reports-burst-grid-popup.component.html',
    styleUrls: ['./reports-burst-grid-popup.component.scss'],
    standalone: false
})
export class ReportsBurstGridPopupComponent {

  descDetails: any
  title = ''
  showModalVariable = false
  public JSON = JSON;

  @ViewChild('notificationDescModal', { static: true }) decModalRef: CustomModalComponent;

  constructor(private loaderService: LoaderService, private sanitizer: DomSanitizer) { }

  showDescModal(data) {
    this.loaderService.setLocalItem('emlId', data.emlId)
    this.descDetails = data;
    this.title = data.emlSubject;
    this.showModalVariable = true
    this.decModalRef?.show();
    const decoded = this.decodeHtml(this.descDetails.emlBody);
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(decoded);
  }
  hideModalClose() {
    this.showModalVariable = false
    this.decModalRef?.hide()
  }

  extractEmail() {
    // Decode HTML entities and remove angle brackets
    const decoded = this.descDetails.emlTo.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    const match = decoded.match(/<(.+?)>/);
    return match ? match[1] : decoded;
  }

  safeHtml: SafeHtml = '';
  decodeHtml(html: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  handleClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName === 'A' && target.innerText == 'here') {
      event.preventDefault();
      const url = (target as HTMLAnchorElement).href;
      if (url.includes('goto=')) {
        let arr = url.split('goto=');
        window.open(arr[1], '_blank');
      } else {
        window.open(url, '_blank');
      }
    }
  }


}
